// extracted by mini-css-extract-plugin
module.exports = {"container":"UserProfile_container__TqUmN","image":"UserProfile_image__2drBm","name":"UserProfile_name__3QFqz","icon":"UserProfile_icon__1GOI7","logout":"UserProfile_logout__Grra-"};